"use client";

import { createContext, ReactNode, useContext } from "react";
import { UserStore } from "@/app/stores/UserStore";
import { PublicUser } from "@/app/types/auth/PublicUser";

const ServerUserContext = createContext<PublicUser | null>(null);

type Props = {
  user: PublicUser | null;
  children: ReactNode;
};

export default function AuthProvider(props: Props) {
  const { user, children } = props;

  return <ServerUserContext.Provider value={user}>{children}</ServerUserContext.Provider>;
}

export function useAuthUser(): PublicUser | null {
  const storedUser = UserStore((state) => state.user);
  const serverUser = useContext(ServerUserContext);

  return storedUser ?? serverUser;
}
